import balanceText from "balance-text";

window.balanceText = balanceText;
